import Head from 'next/head';

import { getServerSidePropsStatusWrapper } from '@kc-console/guard';

import type { NextPageWithLayout } from '@/application/types';

import { EventsTemplate } from '@/pages/events/ui';
import { getServiceConstants } from '@/shared/config/routes';

const EventsPage: NextPageWithLayout = () => {
  const { EVENT_TITLE } = getServiceConstants();
  return (
    <>
      <Head>
        <title>{EVENT_TITLE}</title>
      </Head>
      <EventsTemplate />
    </>
  );
};

export default EventsPage;

export const getServerSideProps = getServerSidePropsStatusWrapper();
